import React, { Component } from 'react'
import { findDOMNode } from 'react-dom'
import screenfull from 'screenfull'
import Hammer from 'hammerjs'
import mousetrap from 'mousetrap'

import classNames from './Presentation.css'
import KenBurns from './KenBurns'
import Floating from './Floating'
import PresentOptionsForm from './PresentOptionsForm'
import Icon from '../Icon'
import Stars from '../Stars'
import ImagePage from '../../pages/Image'
import ImageMenu from '../image/ImageMenu'
import { imageDate } from '../../utils/date'
import { shuffle } from '../../utils/array'
import { getEventTitle } from '../../utils/string'
import { IS_IOS } from '../../constants'

export default class Presentation extends Component {
  state = {
    showControls: false,
    showPresentOptions: false,
    paused: false,
    showImageInfo: null,
    index: 0, // Controlled by deeper presentation component
    // Present options overrides
    type: null,
    speed: null,
    transition: null
  }
  images = getImages(this.props)
  componentDidMount () {
    this.hammer = new Hammer(findDOMNode(this))
    this.hammer.on('swipeleft', this.prevSlide)
    this.hammer.on('swiperight', this.nextSlide)
    mousetrap.bind('left', this.prevSlide)
    mousetrap.bind('right', this.nextSlide)
    mousetrap.bind('escape', this.onClose)
  }
  componentWillReceiveProps (nextProps) {
    this.images = getImages(nextProps)
  }
  componentWillUnmount () {
    this.hammer.destroy()
  }
  onClickPresentation = e => {
    const preventHide = isDescendant(this.refs.topbar, e.target)
    if (this.state.showControls && !preventHide) {
      this.setState({ showControls: false })
    } else {
      this.setState({ showControls: true })
    }
  }
  onClickPresentOptions = () => {
    this.setState({ showPresentOptions: true })
    this.onOpenOverlay()
  }
  onCancelPresentOptions = () => {
    this.setState({ showPresentOptions: false })
    this.onCloseOverlay()
  }
  onSubmitPresentOptions = data => {
    this.setState({
      type: data.presentation_type,
      speed: data.presentation_speed,
      transition: data.presentation_transition
    })
    this.onCancelPresentOptions()
  }
  onChangeSlide = index => {
    this.setState({ index })
  }
  onToggleFullscreen = () => {
    screenfull.toggle()
  }
  onClose = () => {
    if (screenfull.isFullscreen) {
      screenfull.exit()
    }
    this.props.onClose()
  }
  openImageInfo = (e, id) => {
    e.stopPropagation()
    this.setState({ showImageInfo: id })
    this.onOpenOverlay()
  }
  closeImageInfo = (e) => {
    e.stopPropagation()
    this.setState({ showImageInfo: null })
    this.onCloseOverlay()
  }
  onOpenOverlay = () => {
    this.setState({
      paused: true,
      pausedInBackground: this.state.paused
    })
  }
  onCloseOverlay = () => {
    this.setState({
      paused: this.state.pausedInBackground
    })
  }
  // Methods called from outide
  pause = () => {
    this.setState({ paused: true })
    this.props.onPause && this.props.onPause()
  }
  play = () => {
    this.setState({ paused: false })
    this.props.onPlay && this.props.onPlay()
  }
  prevSlide = () => this.refs.presentation.prevSlide()
  nextSlide = () => this.refs.presentation.nextSlide()
  render () {
    const { onSkip, onStartAgain, queueName, playlistName, albumName, ...props } = this.props
    const { showControls, paused, index } = this.state
    const image = props.entities && props.entities.images[this.images[index]]
    const type = this.state.type || this.props.type
    const options = {
      delay: this.state.speed || this.props.options.delay,
      transition: this.state.transition || this.props.options.transition
    }
    return (
      <div className={classNames.wrapper} onClick={this.onClickPresentation}>
        {type === 'kenburns' &&
          <KenBurns
            ref='presentation'
            {...props}
            options={options}
            images={this.images}
            paused={paused}
            onChangeSlide={this.onChangeSlide}
          />
        }
        {type === 'floating' &&
          <Floating
            ref='presentation'
            {...props}
            options={options}
            images={this.images}
            paused={paused}
            onChangeSlide={this.onChangeSlide}
            openImageInfo={this.openImageInfo}
          />
        }
        <div className={showControls ? classNames.controls : classNames.controlsHidden}>
          <div className={classNames.topBar} ref='topbar'>
            <div className={classNames.progress}>
              {this.props.imagesPlayedCount + index + 1} of {props.showTotalCount || props.count}
            </div>
            <button className={classNames.controlButton} onClick={onStartAgain} disabled={!onStartAgain}>
              <Icon icon='restart' />
            </button>
            <button
              className={classNames.controlButton}
              onClick={() => this.refs.presentation.prevSlide()}
              disabled={type === 'floating'}>
              <Icon icon='rewind' />
            </button>
            <button className={classNames.controlButton} onClick={paused ? this.play : this.pause}>
              <Icon icon={paused ? 'play' : 'pause'} />
            </button>
            <button
              className={classNames.controlButton}
              onClick={() => this.refs.presentation.nextSlide()}
              disabled={type === 'floating'}>
              <Icon icon='forward' />
            </button>
            <button className={classNames.controlButton} onClick={onSkip} disabled={!onSkip}>
              <Icon icon='skip' />
            </button>
            {screenfull.enabled && !IS_IOS &&
              <button className={classNames.controlButton} onClick={this.onToggleFullscreen}>
                <Icon icon='fullscreen' size={24} />
              </button>
            }
            <button className={this.props.anonymousUser ? classNames.settingsButtonCorner : classNames.settingsButton} onClick={this.onClickPresentOptions}>
              <Icon icon='settings' />
            </button>
            {!this.props.anonymousUser &&
              <button className={classNames.closeButton} onClick={this.onClose}>
                <Icon icon='close' size={28} />
              </button>
            }
            {this.props.channelDebug && !this.props.anonymousUser &&
              <button className={classNames.debugButton} onClick={this.props.onShowDebugOverlay}>
                Debug
              </button>
            }
            {this.props.channelInfo && !this.props.anonymousUser &&
              <button className={classNames.infoButton} onClick={this.props.onShowInfoOverlay}>
                Info
              </button>
            }
          </div>
          {!this.props.anonymousUser &&
            <ul className={classNames.bottomBar}>
              {image && image._keywords && type === 'kenburns' &&
                <li><strong>Event:</strong> {getEventTitle(image._event)}</li>
              }
              {albumName &&
                <li><strong>Album:</strong> {albumName}</li>
              }
              {playlistName &&
                <li><strong>Playlist:</strong> {playlistName}</li>
              }
              {queueName &&
                <li><strong>Queue:</strong> {queueName}</li>
              }
            </ul>
          }
          {image && type === 'kenburns' &&
            <div className={classNames.tools} onClick={e => e.stopPropagation()}>
              {!this.props.anonymousUser &&
                <ImageMenu
                  image={image}
                  getImageSource={this.props.getImageSource}
                  hidePresentOptions
                  showInfoLink={false}
                  canShareInternal={this.props.canShareImagesInternal}
                  canShareExternal={this.props.canShareImagesExternal}
                  style={{ right: '40px' }}
                  onOpen={this.onOpenOverlay}
                  onClose={this.onCloseOverlay}
                />
              }
              <button onClick={e => this.openImageInfo(e, this.images[index])} className={classNames.info}>
                <Icon icon='info' />
              </button>
              <Stars
                className={classNames.stars}
                rating={image._rating}
                image={image}
                clickable
                whiteStars
                showFlag
                onFlag={this.onOpenOverlay}
                onCloseFlag={this.onCloseOverlay}
              />
            </div>
          }
        </div>
        {this.state.showImageInfo &&
          <div className={classNames.imageInfoOverlay} onClick={this.closeImageInfo}>
            <div className={classNames.imageInfo} onClick={e => e.stopPropagation()}>
              <ImagePage params={{ id: this.state.showImageInfo }} onClickThumbnail={() => {}} />
            </div>
          </div>
        }
        {this.props.showDebugOverlay &&
          <div className={classNames.imageInfoOverlay} onClick={this.props.onHideDebugOverlay}>
            <div className={classNames.debugModal} onClick={e => e.stopPropagation()}>
              {this.props.channelDebug}
            </div>
          </div>
        }
        {this.props.showInfoOverlay &&
          <div className={classNames.imageInfoOverlay} onClick={this.props.onHideInfoOverlay}>
            <div className={classNames.debugModal} onClick={e => e.stopPropagation()}>
              {this.props.channelInfo}
            </div>
          </div>
        }
        {this.state.showPresentOptions &&
          <div className={classNames.imageInfoOverlay} onClick={e => e.stopPropagation()}>
            <PresentOptionsForm
              onSubmit={this.onSubmitPresentOptions}
              onCancel={this.onCancelPresentOptions}
              presentTypeSelected={this.props.presentTypeSelected}
              initialValues={{
                presentation_type: type,
                presentation_speed: options.delay,
                presentation_transition: options.transition
              }}
              confirmText='Update'
              hideSort
              rangeInputType={IS_IOS ? 'number' : 'range'}
            />
          </div>
        }
      </div>
    )
  }
}

function getImages ({ images, entities, options, count }) {
  return sortImages(images, entities, options).slice(0, count)
}

function sortImages (images, entities, options) {
  if (!options || !options.sort) {
    return images
  }
  const [sort, operator] = options.sort.split('-')
  if (sort === 'date') {
    return images.sort((a, b) => {
      const dateA = imageDate(entities.images[a])
      const dateB = imageDate(entities.images[b])
      if (dateA && dateB) {
        return operator === 'asc' ? dateA > dateB : dateA < dateB
      }
      return 0
    })
  }
  if (sort === 'rating') {
    return images.sort((a, b) => {
      const ratingA = entities.images[a]._rating
      const ratingB = entities.images[b]._rating
      if (ratingA && ratingB) {
        return operator === 'asc' ? ratingA > ratingB : ratingA < ratingB
      }
      return 0
    })
  }
  if (sort === 'random') {
    return shuffle(images)
  }
  return images
}

function isDescendant (parent, child) {
  let node = child.parentNode
  while (node !== null) {
    if (node === parent) {
      return true
    }
    node = node.parentNode
  }
  return false
}



// WEBPACK FOOTER //
// ./src/components/present/Presentation.js